import "./index.less"

export default () => {
    if (!customElements.get('jky-video')) {
        customElements.define('jky-video', class JkyVideo extends HTMLElement {
            constructor() {
                super()

                this.isMobile = window.innerWidth < 1024

                if (
                    (this.isMobile && this.classList.contains('jky-video--pc')) ||
                    (!this.isMobile && this.classList.contains('jky-video--mb'))
                ) return

                this.videoInfo = {
                    type: this.getAttribute("video-type"),
                    autoplay: this.getAttribute("video-autoplay") === "true",
                    controls: this.getAttribute("video-controls") === "true",
                    loop: this.getAttribute("video-loop") === "true",
                    src: this.getAttribute("video-src"),
                }

                if (this.videoInfo.type === "youtube") {
                    this.videoInfo.youtube_id = getYoutubeId(this.videoInfo.src);
                    this.videoInfo.youtube_embed = `https://www.youtube.com/embed/${this.videoInfo.youtube_id}`;
                }

                if(!this.videoInfo.src) return;
 
                this.setPoster()

                this.poster = this.querySelector(".jky-video-poster_container");
                this.poster.addEventListener('click', this.loadContent.bind(this));

                // 视频进入视口监听播放
                const deferredMediaObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const video = entry.target.querySelector('video')
                            // 如果视频已经播放完了，再次进入则不会自动播放。防止多个视频在视窗内同时播放
                            if (video?.getAttribute('data-played') !== 'true') {
                                entry.target.loadContent(false)
                            }
                        } else {
                            entry.target.pause()
                        }
                    });
                });

                if (this.videoInfo.autoplay) {
                    deferredMediaObserver.observe(this)
                }
            }

            renderMediaDom() {
                let media_dom = ''
                switch (this.videoInfo.type) {
                    case 'mp4':
                        // 添加fullscreenchange事件监听，处理安卓Chrome全屏问题
                        const isAndroid = /Android/i.test(navigator.userAgent);
                        const fullscreenAttributes = isAndroid ? 'x5-video-orientation="landscape" x5-video-player-fullscreen="true"' : '';
                        
                        media_dom = `<video class="jky-video_media" x5-video-player-type="h5-page" webkit-playsinline="playsinline" playsinline="playsinline" autoplay="autoplay" muted="muted" ${this.videoInfo.controls ? 'controls="controls"' : ''} preload="metadata" ${this.videoInfo.loop ? 'loop' : ''} ${fullscreenAttributes} "&width=1500"><source src="${this.videoInfo.src}" type="video/mp4"></video>`
                        break;
                    case 'youtube':
                        const y_loop = this.videoInfo.loop ? `1&playlist=${this.videoInfo.youtube_id}` : '0';
                        media_dom = `<iframe class="jky-video_media jky-media_youtube js-youtube global-settings-popup" src="${this.videoInfo.youtube_embed}?enablejsapi=1&autoplay=1&loop=${y_loop}&mute=1&branding=0&autohide=0&cc_load_policy=0&modestbranding=3&playsinline=1&rel=0&showinfo=0&wmode=opaque" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;" frameborder="0" allowfullscreen="1" title="Jackery"></iframe>`
                    default:
                        break;
                }
                return $(media_dom)
            }

            loadContent(focus = true) {
                if (!this.deferredElement) {
                    const media_dom = this.renderMediaDom();
                    $(this).append(media_dom);

                    this.setAttribute('loaded', true);
                    this.deferredElement = this.querySelector('video, model-viewer, iframe')
                    
                    // 为视频添加全屏事件监听
                    if (this.deferredElement.nodeName === 'VIDEO') {
                        const isAndroid = /Android/i.test(navigator.userAgent);
                        if (isAndroid) {
                            // 添加全屏变化事件监听
                            this.deferredElement.addEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));
                            this.deferredElement.addEventListener('webkitfullscreenchange', this.handleFullscreenChange.bind(this));
                        }
                    }
                } else {
                    if (focus) this.deferredElement.focus();

                    // mp4 播放
                    if (this.deferredElement.nodeName == 'VIDEO' && this.videoInfo.autoplay) {
                        this.deferredElement.play();
                        this.isPlaying = true;
                        setTimeout(() => {
                            this.initVideoEvent()
                        }, 20);
                    }

                    // youtube 播放
                    if (this.videoInfo.type === 'youtube' && this.videoInfo.autoplay) {
                        this.deferredElement.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                        this.isPlaying = true;
                    }
                }
            }
            
            // 处理全屏变化事件
            handleFullscreenChange() {
                if (document.fullscreenElement || document.webkitFullscreenElement) {
                    const video = document.fullscreenElement || document.webkitFullscreenElement;
                    if (video.tagName.toLowerCase() === 'video') {
                        // 强制设置视频样式，确保全屏正确显示
                        video.style.objectFit = 'contain';
                        video.style.width = '100vw';
                        video.style.height = '100vh';
                    }
                }
            }

            jsPlay() { // js手动调用播放
                if (!this.deferredElement) {
                    const media_dom = this.renderMediaDom();
                    $(this).append(media_dom);

                    this.setAttribute('loaded', true);
                    this.deferredElement = this.querySelector('video, model-viewer, iframe')
                }
                if (this.deferredElement) {
                    if (focus) this.deferredElement.focus();

                    // mp4 播放
                    if (this.deferredElement.nodeName == 'VIDEO') {
                        this.deferredElement.play();
                        this.isPlaying = true;
                    }

                    // youtube 播放
                    if (this.videoInfo.type === 'youtube') {
                        this.deferredElement.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                        this.isPlaying = true;
                    }
                }
            }

            setCurrent(curr = 0) { // 设置视频播放起始时间
                // mp4 播放
                if (this.deferredElement.nodeName == 'VIDEO') {
                    this.deferredElement.currentTime = curr
                }

                // youtube 播放
                if (this.videoInfo.type === 'youtube') {
                    this.deferredElement.contentWindow.postMessage('{"event":"command","func":"' + 'seekTo' + `","args":[${curr}, true]}`, '*')
                }
            }

            pause() {
                if (this.deferredElement) {
                    this.pauseAllMedia(this);
                    this.isPlaying = false;
                }
            }

            pauseAllMedia(dom) {
                dom.querySelectorAll('video').forEach((video) => video.pause());
                dom.querySelectorAll(".jky-media_youtube").forEach((video) => {
                    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                });
            }

            // 截屏指定video 帧图片
            captureFrame(t = 1, src = '') {
                return new Promise(reslove => {
                    var video = document.createElement('video');
                    video.currentTime = t;
                    video.muted = true
                    video.autoplay = true
                    video.src = src
                    video.setAttribute("crossOrigin", "anonymous")

                    video.oncanplay = () => {
                        var canvas = document.createElement('canvas');
                        canvas.width = video.videoWidth
                        canvas.height = video.videoHeight
                        const ctx = canvas.getContext("2d")
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
                        canvas.toBlob((blob) => {
                            const url = URL.createObjectURL(blob)
                            reslove({
                                blob,
                                url
                            })
                        })
                    }
                })
            }

            async setPoster() { // 没有上传封面图且视频类型为MP4，则使用video指定帧作为poster
                const img = this.querySelector(".jky-video-poster_container img")
                if(!img) return;
                if (!img.getAttribute("src") && this.videoInfo.src && this.videoInfo.type === 'mp4') {
                    if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true ) { // FIX: safari中重复请求video src会自动播放
                        $(this).addClass("browser-safari");
                        return
                    }
                    const res = await this.captureFrame(1, this.videoInfo.src)
                    img.src = res.url
                    img.classList.remove("loading_img");
                    img.classList.add("loaded_img");
                }
                
                if (!img.getAttribute("src") && this.videoInfo.youtube_id && this.videoInfo.type === 'youtube') {
                    // https://i.ytimg.com/vi/NIYzKI4mXQQ/maxresdefault.jpg
                    const res = `https://i3.ytimg.com/vi/${this.videoInfo.youtube_id}/hqdefault.jpg`
                    img.src = res
                    img.classList.remove("loading_img");
                    img.classList.add("loaded_img");
                }
            }

            // 判断MP4视频是否满足播放条件
            isCanPlayVideo() {
                let flag = false
                if(this.videoInfo.type === 'mp4') {
                    const state = this.deferredElement?.readyState || 0
                    console.log(state)
                    return flag = state === 4
                }
                return flag
            }

            // 开启声音
            turnOnSound() {
                if (!this.deferredElement) {
                    const media_dom = this.renderMediaDom();
                    $(this).append(media_dom);

                    this.setAttribute('loaded', true);
                    this.deferredElement = this.querySelector('video, model-viewer, iframe')
                }
                if (this.deferredElement && this.videoInfo.type === 'mp4') {
                    this.deferredElement.muted = false
                }
            }
            // 关闭声音
            turnoffSound() {
                if (!this.deferredElement) {
                    const media_dom = this.renderMediaDom();
                    $(this).append(media_dom);

                    this.setAttribute('loaded', true);
                    this.deferredElement = this.querySelector('video, model-viewer, iframe')
                }
                if (this.deferredElement && this.videoInfo.type === 'mp4') {
                    this.deferredElement.muted = true
                }
            }

            // 判断MP4格式视频加载
            onVideo(cb) {
                if (!this.deferredElement) {
                    const media_dom = this.renderMediaDom();
                    $(this).append(media_dom);

                    this.setAttribute('loaded', true);
                    this.deferredElement = this.querySelector('video, model-viewer, iframe')
                }
                if (this.deferredElement && this.videoInfo.type === 'mp4') {
                    const video = this.deferredElement
                    video.addEventListener('loadedmetadata', function() {
                        cb()
                    })
                }
            }

            initVideoEvent() {
                if (this.deferredElement && this.videoInfo.type === 'mp4') {
                    const video = this.deferredElement
                    video.addEventListener('play', () => {
                        console.log("MP4 video 播放了")
                        publish(PUB_SUB_EVENTS.videoPlay, {
                            info: this.videoInfo,
                            player: this
                        });
                    })
                }
            }

            initYoutubeEvent() {
                // if(!window.YT) {
                //     const tag = document.createElement('script');
                //     tag.src = 'https://www.youtube.com/iframe_api';
                //     window.onYouTubeIframeAPIReady = function () {
                //         window.youTubeReady = true;
                //         $('body').trigger('youTubeReady');
                //         // setTimeout(() => {
                //         //     $(window).off('scroll.' + 'video-slideshow__youtubeAPI')
                //         // }, 200);
                //     }
                // }
            }
        })
    }
}